import {
  CrudTableViewConfig,
  CrudViewColumnType,
  InputSize
} from '@rappider/rappider-components/utils';

/**
 * Configuration for displaying relations in a list-grid table format
 * Matches the example image with columns: Name, Source Model, Type, Target Model, Through Model
 */
export const relationsListGridConfig: CrudTableViewConfig = {
  columns: [
    {
      title: 'Name',
      fieldName: 'name',
      type: CrudViewColumnType.Text,
      width: '150px',
      sortable: false
    },
    {
      title: 'Source Model',
      fieldName: 'sourceModel',
      type: CrudViewColumnType.Text,
      width: '120px',
      sortable: false
    },
    {
      title: 'Type',
      fieldName: 'type',
      type: CrudViewColumnType.Text,
      width: '100px',
      sortable: false
    },
    {
      title: 'Target Model',
      fieldName: 'targetModel',
      type: CrudViewColumnType.Text,
      width: '120px',
      sortable: false
    },
    {
      title: 'Through Model',
      fieldName: 'throughModel',
      type: CrudViewColumnType.Text,
      width: '120px',
      sortable: false
    },
    {
      title: 'Description',
      fieldName: 'description',
      type: CrudViewColumnType.Text,
      sortable: false
    }
  ],
  showPagination: false,
  size: InputSize.Small,
  filterable: false,
  sortable: false,
  searchable: false,
  columnVisibilitySelectable: false,
  itemActions: [],
  listActions: []
};
